export default __webpack_public_path__ + "static/media/icon-footer-twitter.8e7b3ef7.svg";